module.exports = __webpack_public_path__ + "media/images/sp/specials/common/present_omiya_open-9c8496fe01d8d3bc123d66c83abc69c0.png";